var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"tema"}},[_c('iframe',{ref:"iframeContent",attrs:{"id":"iframeContent","width":"100%","height":_vm.windowHeight - 7,"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }